import React, {Component} from "react";
import {orderApiService} from "../../services/otodis/OrderApiService";
import {Col, Divider, Row, Spin} from "antd";
import currencyFormat from "../../helper/currencyFormat";

class DetailOrder extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);
        this.initState = {
            orderCode: "",
            fetchingDetailOrder: false,
            orderData: {},
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            orderCode: this.props.orderCode,
            fetchingDetailOrder: true,
        });

        await this.showOrderDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        // if (this.props.orderCode !== prevProps.orderCode) {
        //     await this.promisedSetState({
        //         orderCode: this.props.orderCode,
        //         fetchingDetailOrder: true,
        //     });
        //     await this.showOrderDetail();
        // }

        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                orderCode: this.props.orderCode,
                fetchingDetailOrder: true,
            });
            await this.showOrderDetail();
        }
    }

    showOrderDetail = async () => {
        const dealerCode = "DLR#" + this.state?.orderCode.split(/#|-/)?.[1] + "#" + this.state?.orderCode.split(/#|-/)?.[2]

        orderApiService.getOrder({
            dealerCode: dealerCode,
            orderCode: this.state.orderCode
        }).then(async value => {
            await this.promisedSetState({
                orderData: value.data.data[0],
                fetchingDetailOrder: false,
            });
        }).catch(async reason => {
            await this.promisedSetState({
                orderData: {},
                fetchingDetailOrder: false,
            });
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailOrder ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <div style={!this.state.fetchingDetailOrder ? {} : {display: 'none'}}>
                    <Row>
                        <Col span={8} className={`col-grey`}>Kode Order:</Col>
                        <Col span={16}>{this.state.orderData?.order_code}</Col>
                        <Col span={8} className={`col-grey`}>ID Order AMH:</Col>
                        <Col span={16}>{this.state.orderData?.amh_order_number}</Col>
                        <Col span={8} className={`col-grey`}>Tanggal Buat:</Col>
                        <Col span={16}>{this.state.orderData?.order_create_date}</Col>
                        <Col span={8} className={`col-grey`}>Tanggal Closing:</Col>
                        <Col span={16}>{this.state.orderData?.order_closing_date}</Col>
                        <Col span={8} className={`col-grey`}>Tanggal Delivery:</Col>
                        <Col span={16}>{this.state.orderData?.order_delivery_date}</Col>
                        <Col span={8} className={`col-grey`}>Nama Dealer:</Col>
                        <Col span={16}>{this.state.orderData?.dealer_name}</Col>
                        <Col span={8} className={`col-grey`}>Marketing Code:</Col>
                        <Col span={16}>{this.state.orderData?.marketing_code}</Col>
                        <Col span={8} className={`col-grey`}>Marketing Name:</Col>
                        <Col span={16}>{this.state.orderData?.marketing_name}</Col>
                        <Col span={8} className={`col-grey`}>Payment Method:</Col>
                        <Col span={16}>{this.state.orderData?.order_payment_method}</Col>
                        <Col span={8} className={`col-grey`}>Status Order:</Col>
                        <Col span={16}>{this.state.orderData?.order_status}</Col>
                        <Col span={8} className={`col-grey`}>Kode Leasing:</Col>
                        <Col span={16}>{this.state.orderData?.leasing_code}</Col>
                        <Col span={8} className={`col-grey`}>Nama Leasing:</Col>
                        <Col span={16}>{this.state.orderData?.leasing_name}</Col>
                        <Col span={8} className={`col-grey`}>Tanggal PO leasing:</Col>
                        <Col span={16}>{this.state.orderData?.leasing_po_date}</Col>
                    </Row>

                    <Divider orientation="left" plain>
                        <span className={`divider-stock-purchase`}>Customer</span>
                    </Divider>
                    <Row>
                        <Col span={8} className={`col-grey`}>Nama pada BPKB:</Col>
                        <Col span={16}>{this.state.orderData?.customer_doc_name}</Col>
                        <Col span={8} className={`col-grey`}>Nomor KTP:</Col>
                        <Col span={16}>{this.state.orderData?.customer_identity_number}</Col>
                        <Col span={8} className={`col-grey`}>Nama Customer:</Col>
                        <Col span={16}>{this.state.orderData?.customer_name}</Col>
                        <Col span={8} className={`col-grey`}>Nama Provinsi:</Col>
                        <Col span={16}>{this.state.orderData?.province_name}</Col>
                        <Col span={8} className={`col-grey`}>Nama Kota:</Col>
                        <Col span={16}>{this.state.orderData?.city_name}</Col>
                        <Col span={8} className={`col-grey`}>Nama Kecamatan:</Col>
                        <Col span={16}>{this.state.orderData?.district_name}</Col>
                        <Col span={8} className={`col-grey`}>Nama Kelurahan:</Col>
                        <Col span={16}>{this.state.orderData?.sub_district_name}</Col>
                        <Col span={8} className={`col-grey`}>Alamat:</Col>
                        <Col span={16}>{this.state.orderData?.address}</Col>
                    </Row>


                    <Divider orientation="left" plain>
                        <span className={`divider-stock-purchase`}>Kendaraan</span>
                    </Divider>
                    <Row>
                        <Col span={8} className={`col-grey`}>Kode Stock:</Col>
                        <Col span={16}>{this.state.orderData?.stock_unit_code}</Col>
                        <Col span={8} className={`col-grey`}>Merk:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_brand_name}</Col>
                        <Col span={8} className={`col-grey`}>Model:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_model_name}</Col>
                        <Col span={8} className={`col-grey`}>Kode Variant:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_variant_code}</Col>
                        <Col span={8} className={`col-grey`}>Nama Variant:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_variant_name}</Col>
                        <Col span={8} className={`col-grey`}>Kode Warna:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_color_code}</Col>
                        <Col span={8} className={`col-grey`}>Nama Warna:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_color_name}</Col>
                        <Col span={8} className={`col-grey`}>Nomor Rangka:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_chassis_number}</Col>
                        <Col span={8} className={`col-grey`}>Nomor Mesin:</Col>
                        <Col span={16}>{this.state.orderData?.vehicle_engine_number}</Col>
                    </Row>

                    <Divider orientation="left" plain>
                        <span className={`divider-stock-purchase`}>Harga Kendaraan</span>
                    </Divider>
                    <Row>
                        {/* <Col span={8} className={`col-grey`}>Harga Pembelian:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_purchase_price)}</Col>
                        <Col span={8} className={`col-grey`}>Discount:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_purchase_discount)}</Col>
                        <Col span={8} className={`col-grey`}>Harga Setelah Diskon:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_basic_purchase_price)}</Col>
                        <Col span={8} className={`col-grey`}>VAT:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_purchase_vat)}</Col>
                        <Col span={8} className={`col-grey`}>Harga Final Pembelian:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_fixed_purchase_price)}</Col> */}
                        <Col span={8} className={`col-grey`}>Harga Penjualan:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.vehicle_sales_price)}</Col>
                        <Col span={8} className={`col-grey`}>DP Order:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.order_down_payment)}</Col>
                        <Col span={8} className={`col-grey`}>Discount Order:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.order_discount)}</Col>
                        <Col span={8} className={`col-grey`}>Repayment Leasing:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.leasing_repayment)}</Col>
                        <Col span={8} className={`col-grey`}>Subsidi Leasing:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.leasing_subsidies)}</Col>
                        <Col span={8} className={`col-grey`}>Estimasi Cost Transfer:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.transfer_title_cost_estimation)}</Col>
                        <Col span={8} className={`col-grey`}>Real Cost Transfer:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.transfer_title_cost_real)}</Col>
                        <Col span={8} className={`col-grey`}>Insentif Out:</Col>
                        <Col span={16}>{currencyFormat(this.state.orderData?.incentive_out)}</Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default DetailOrder;
